import { PageModel } from "./PageModel";

class PiecesOfHistoryPage extends PageModel {

}

export { PiecesOfHistoryPage }